export const baseUrl = '/company-categories'
